<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-send`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 17.003v-13c0-1.464 1.512-2.415 2.817-1.826l.134.066 37 20c1.35.73 1.397 2.626.14 3.437l-.14.082-37 20c-1.288.697-2.843-.182-2.946-1.61L5 44.002v-13a2 2 0 01.467-1.284l.119-.13 5.586-5.585-5.586-5.586a2 2 0 01-.578-1.238L5 17.003v-13 13zm31.094 8.999H14.829L9 31.832v8.816l27.094-14.646zM9 7.357v8.817l5.828 5.828h21.266L9 7.357z"/></svg>
</template>
<script>

export default {
  name: 'IconSend',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
